<template>
    <div>
        <v-container fluid>
            <h1 class="display-1" v-t="'title.dashboard'"></h1>
        </v-container>
        <v-container fluid grid-list-lg class="no-padding-mobile">
            <v-layout row wrap>
                <v-flex xs12 lg6>
                    <TrapList
                        :pagination="false"
                        show-refresh
                        sort-by="status"
                        filter-status="triggered"
                        :title="$t('title.last_status_trap')"
                        show-seeall
                    >
                        <div slot="noresults">{{ $t("message.all_trap_armed") }}</div>
                    </TrapList>
                </v-flex>
                <v-flex xs12 lg6>
                    <TrapList
                        :pagination="false"
                        show-refresh
                        sort-by="status"
                        :title="$t('title.last_updated_status_trap')"
                        show-seeall
                    />
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TrapList from "@/components/TrapList"

export default {
    components: { TrapList },
}
</script>
